module.exports = __webpack_public_path__ + "img/background-vectors.63856104.svg";